import React, { useState } from 'react';
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";

import data from "../../../data.js"

import Expand from './images/expand-1.png';
import Expand2x from './images/expand-1@2x.png';
import Expand3x from './images/expand-1@3x.png';

import ExpandSmall from './images/expand-4.png';
import ExpandSmall2x from './images/expand-4@2x.png';
import ExpandSmall3x from './images/expand-4@3x.png';

let cx = classNames.bind(styles);

const Faq = (props) => {
    const [question, setQuestion] = useState(0);
    const [seeMore, setSeeMore] = useState(0);

    return (
        <div className={styles.faq}>
            <div className={styles.header}>Frequently Asked Questions</div>
            
            <Row type="flex" justify="center" align="middle">
                <Col md={16} xl={8}>
                    <div className={cx(question === 1 ? styles.expanded : '')}>
                        <div className={styles.question} onClick={(evt) => {setQuestion(question === 1 ? 0 : 1)}}>
                            <div className={styles.questionExpand}>
                                <img src={Expand} alt="expand"/>
                            </div>
                            <div className={styles.questionText}>How does HP Instant Ink work?</div>
                        </div>
                        
                        <div className={styles.answer}>
                            <p>When you sign up for an HP Instant Ink plan, you pay a 
                            monthly fee to print a defined number of pages per month. 
                            The plans are based on the number of pages that you print, 
                            not on how many ink cartridges you use. Your monthly fee 
                            pays for ink, shipping, and recycling. If you do not print 
                            all of your plan pages in a month, you can roll over up to 
                            two times the number of pages per month in your plan. If 
                            you print more pages, there is an additional charge but you 
                            are still paying the same price per page as your base plan. 
                            A printed page counts the same whether it’s black and white, 
                            a color document, or a photo. There are { data.plans.length } plans:</p>
                            

                            { data.plans.map((plan) => (
                                <div className={styles.plan} key={plan.id}>
                                    <p className={styles.price}>{ plan.price }</p>
                                    <Row>
                                        <Col sm={9} className={styles.rowLabel}>Pages per month</Col>
                                        <Col sm={15}>{ plan.pages }</Col>
                                    </Row>
                                    {(plan.rollover ? (
                                        <Row>
                                            <Col sm={9} className={styles.rowLabel}>Rollover pages total</Col>
                                            <Col sm={15}>Up to { plan.rollover }</Col>
                                        </Row>
                                    ) : null)}
                                    <Row>
                                        <Col sm={9} className={styles.rowLabel}>Additional pages</Col>
                                        <Col sm={15}>Each additional set of { plan.overageBlockSize } pages for just { plan.overageBlockPrice }</Col>
                                    </Row>
                                </div>
                            )) }
                            
                            <p>
                                There is no annual fee and you can cancel or 
                                change plans anytime without penalty.5 As part 
                                of the service, HP will send you HP Instant Ink
                                replacement cartridges and postage-paid 
                                recycling envelopes, before you run out of ink, 
                                at no additional cost.2 Your billing month 
                                starts when you insert an HP Instant Ink 
                                cartridge in your enrolled printer.
                            </p>
                            <p>
                                Your printer tells us that you’re low on ink, so
                                we will know when to send you more. You will 
                                always have ink when you need it.2 HP Instant 
                                Ink cartridges can only be used in the printer 
                                that you have enrolled. Used HP Instant Ink 
                                cartridges must be returned in the postage-paid 
                                recycling envelopes provided by HP. Returned 
                                cartridges will be recycled by HP Planet 
                                Partners.
                            </p>
                        </div>
                    </div>
                    
                    <div className={cx(question === 2 ? styles.expanded : '')}>
                        <div className={styles.question} onClick={(evt) => {setQuestion(question === 2 ? 0 : 2)}}>
                            <div className={styles.questionExpand}>
                                <img src={Expand} alt="expand"/>
                            </div>
                            <div className={styles.questionText}>Can I cancel or change my plan anytime?</div>
                        </div>
                        
                        <div className={styles.answer}>
                            <p>Yes. There is no obligation or commitment beyond 
                            your first month. You may cancel your service or 
                            change plans at any time without penalty.
                            To change your plan or cancel your service, sign in 
                            at <a target="_blank" href="https://instantink.hpconnected.com">hpinstantink.com</a>. 
                            Expand the <strong>My Plan</strong> section and 
                            click <strong>Edit</strong>, next to <strong>HP Instant Ink Plan</strong>.  
                            You can choose to make a plan upgrade effective 
                            immediately and retroactively apply to the current 
                            billing cycle, or have the upgrade take effect the 
                            first day of the next billing cycle. Plan downgrade 
                            changes and cancellation are effective the first 
                            day of the next billing cycle. For more details, 
                            see the <a href="/terms" target="_blank">HP Instant Ink Terms of Service</a>
                            .</p>
                        </div>
                    </div>
                    
                    <div className={cx(question === 3 ? styles.expanded : '')}>
                        <div className={styles.question} onClick={(evt) => {setQuestion(question === 3 ? 0 : 3)}}>
                            <div className={styles.questionExpand}>
                                <img src={Expand} alt="expand"/>
                            </div>
                            <div className={styles.questionText}>Will I get cartridges every month?</div>
                        </div>
                        
                        <div className={styles.answer}>
                            <p>No, you will only get cartridges when your printer tells us you need them. HP Instant Ink cartridges are extra high capacity, and they contain months-worth of ink depending on your usage. You can print as much as you want as long as you are enrolled in HP Instant Ink. </p>
                        </div>
                    </div>
                    <div className={cx(question === 4 ? styles.expanded : '')}>
                        <div className={styles.question} onClick={(evt) => {setQuestion(question === 4 ? 0 : 4)}}>
                            <div className={styles.questionExpand}>
                                <img src={Expand} alt="expand"/>
                            </div>
                            <div className={styles.questionText}>What if I don't know how much I print?</div>
                        </div>
                        
                        <div className={styles.answer}>
                            <p>When you sign up for an HP Instant Ink plan, you pay a 
                            monthly fee to print a defined number of pages per month. 
                            The plans are based on the number of pages that you print, 
                            not on how many ink cartridges you use. Your monthly fee 
                            pays for ink, shipping, and recycling. If you do not print 
                            all of your plan pages in a month, you can roll over up to 
                            two times the number of pages per month in your plan. If 
                            you print more pages, there is an additional charge but you 
                            are still paying the same price per page as your base plan. 
                            A printed page counts the same whether it’s black and white, 
                            a color document, or a photo. There are three plans:</p>
                        </div>
                    </div>

                    <div className={cx(styles.showMoreContainer2, seeMore ? styles.show : null)}>
                    
                        <div className={cx(question === 5 ? styles.expanded : '')}>
                            <div className={styles.question} onClick={(evt) => {setQuestion(question === 5 ? 0 : 5)}}>
                                <div className={styles.questionExpand}>
                                    <img src={Expand} alt="expand"/>
                                </div>
                                <div className={styles.questionText}>What are the requirements to enroll?</div>
                            </div>
                            
                            <div className={styles.answer}>
                                <p>To enroll in HP Instant Ink you need:</p>
                                <ul><li>An eligible HP printer listed below:</li></ul>
                                <Row>
                                    <Col sm={12}>
                                        <ul>
                                            <li><p className="faq-text">HP AMP</p></li>
                                            <li><p className="faq-text">HP DeskJet 2600 Series</p></li>
                                            <li><p className="faq-text">HP DeskJet 3630 Series</p></li>
                                            <li><p className="faq-text">HP DeskJet 3720 Series</p></li>
                                            <li><p className="faq-text">HP DeskJet 3750 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 4500 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 4510 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 4520 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5010 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5020 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5030 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5050 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5260 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5530 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5540 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5640 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5660 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 7640 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 6250 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7120 Series</p></li>
                                        </ul>
                                    </Col>
                                    <Col sm={12}>
                                        <ul>
                                            <li><p className="faq-text">HP ENVY Photo 7150 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7160 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7850 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7860 Series</p></li>
                                            <li><p className="faq-text">HP TANGO</p></li>
                                            <li><p className="faq-text">HP TANGO X</p></li>
                                            <li><p className="faq-text">HP OfficeJet 3830 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 4630 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 4650 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 5250 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 5260 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 5740 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6810 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6820 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6950 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6960 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 8010 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 8020 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 8040 Series</p></li>
                                        </ul>
                                    </Col>
                                    <Col sm={12}>
                                        <ul>
                                            <li><p className="faq-text">HP OfficeJet 8702 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 9010 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6830 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6950 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6960 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6970 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8020 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8030 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8210 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8610 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8620 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8630 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8710 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8720 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8730 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8740 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 9010 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 9020 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro Premier</p></li>
                                        </ul>
                                    </Col>
                                </Row>

                                <p className="faq-text">
                                    Need an eligible printer? <a target="_blank" href="http://store.hp.com/us/en/SearchDisplay?client=&amp;searchTerm=HPInstantInkPrinters&amp;search=&amp;charset=utf-8&amp;storeId=10151&amp;catalogId=10051&amp;langId=-1&amp;beginIndex=0&amp;pageSize=50&amp;jumpid=cp_r11549_hho_iieligible_FAQ_090117">Click here</a>
                                </p>

                                <ul className="requirements-list">
                                    <li>Your printer must be connected to the Internet so we know when to send you ink. While enrolled with Instant Ink, your printer will also automatically receive and apply any necessary updates.</li>
                                    <li>A valid email address</li>
                                    <li>A valid payment method (for billing purposes)</li>
                                </ul>
                            </div>{/* Answer  */}
                        </div>{/* Question  */}
                        
                        
                        <div className={cx(question === 6 ? styles.expanded : '')}>
                            <div className={styles.question} onClick={(evt) => {setQuestion(question === 6 ? 0 : 6)}}>
                                <div className={styles.questionExpand}>
                                    <img src={Expand} alt="expand"/>
                                </div>
                                <div className={styles.questionText}>Is my printer eligible for HP Instant Ink?</div>
                            </div>
                            
                            <div className={styles.answer}>
                                <p>Currently, only select new HP printer models are eligible for HP Instant Ink. If you have an older HP printer, it is not compatible with the HP Instant Ink service.</p>

                                <Row>
                                    <Col sm={12}>
                                        <ul>
                                            <li><p className="faq-text">HP AMP</p></li>
                                            <li><p className="faq-text">HP DeskJet 2600 Series</p></li>
                                            <li><p className="faq-text">HP DeskJet 3630 Series</p></li>
                                            <li><p className="faq-text">HP DeskJet 3720 Series</p></li>
                                            <li><p className="faq-text">HP DeskJet 3750 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 4500 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 4510 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 4520 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5010 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5020 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5030 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5050 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5260 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5530 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5540 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5640 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 5660 Series</p></li>
                                            <li><p className="faq-text">HP ENVY 7640 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 6250 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7120 Series</p></li>
                                        </ul>
                                    </Col>
                                    <Col sm={12}>
                                        <ul>
                                            <li><p className="faq-text">HP ENVY Photo 7150 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7160 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7850 Series</p></li>
                                            <li><p className="faq-text">HP ENVY Photo 7860 Series</p></li>
                                            <li><p className="faq-text">HP TANGO</p></li>
                                            <li><p className="faq-text">HP TANGO X</p></li>
                                            <li><p className="faq-text">HP OfficeJet 3830 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 4630 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 4650 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 5250 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 5260 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 5740 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6810 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6820 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6950 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 6960 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 8010 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 8020 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 8040 Series</p></li>
                                        </ul>
                                    </Col>
                                    <Col sm={12}>
                                        <ul>
                                            <li><p className="faq-text">HP OfficeJet 8702 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet 9010 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6830 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6950 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6960 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 6970 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8020 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8030 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8210 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8610 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8620 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8630 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8710 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8720 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8730 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 8740 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 9010 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro 9020 Series</p></li>
                                            <li><p className="faq-text">HP OfficeJet Pro Premier</p></li>
                                        </ul>
                                    </Col>
                                </Row>

                                <p className="faq-text">Need an eligible printer? <a target="_blank" href="http://store.hp.com/us/en/SearchDisplay?client=&amp;searchTerm=HPInstantInkPrinters&amp;search=&amp;charset=utf-8&amp;storeId=10151&amp;catalogId=10051&amp;langId=-1&amp;beginIndex=0&amp;pageSize=50&amp;jumpid=cp_r11549_hho_iieligible_FAQ_090117">Click here</a></p>
                            </div>{/* Answer  */}
                        </div>{/* Question  */}
                
                        
                        
                        <div className={cx(question === 7 ? styles.expanded : '')}>
                            <div className={styles.question} onClick={(evt) => {setQuestion(question === 7 ? 0 : 7)}}>
                                <div className={styles.questionExpand}>
                                    <img src={Expand} alt="expand"/>
                                </div>
                                <div className={styles.questionText}>What if my printing needs change from month to month?</div>
                            </div>
                            
                            <div className={styles.answer}>
                                <p>
                                    Your unused pages are rolled over for you, 
                                    up to two times your monthly plan amount. 
                                    You can print more than your monthly page 
                                    amount and still save. Additional sets of 
                                    pages are automatically available and let 
                                    you print beyond your monthly limit for 
                                    pennies per page. You can also easily change
                                    your monthly plan whenever you want. You can
                                    choose to make a plan upgrade effective 
                                    immediately and retroactively apply to the 
                                    current billing cycle, or have the upgrade 
                                    take effect the first day of the next 
                                    billing cycle. Plan downgrade changes and 
                                    cancellation are effective the first day of 
                                    the next billing cycle. For more details, 
                                    see the <a href="https://instantink.hpconnected.com/terms" target="_blank">HP Instant Ink Terms of Service</a>. 
                                </p>
                            </div>{/* Answer  */}
                        </div>{/* Question  */}
              
                        
                        
                    </div> { /* Show More  */ }

                    <div className={styles.showMoreContainer}>
                        <a className={cx(styles.showMoreText, seeMore ? styles.expanded : null)} href="#" onClick={(evt) =>{ evt.preventDefault(); setSeeMore(!seeMore); }}>{seeMore ? 'Show less' : 'Show more'} <img src={ExpandSmall} alt="expand"/></a>
                    </div>

                    <div className={styles.termsLinkContainer}>
                        <a className={styles.termsLink} href="https://instantink.hpconnected.com/terms">HP Instant Ink Terms of Service</a>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default Faq;
